import React, { FunctionComponent, Fragment } from "react";
import DictionaryProps from "./DictionaryProps.interface";

import { useSelector } from "react-redux";
import isDevelopment from "helpers/isDevelopment";

const Dictionary: FunctionComponent<DictionaryProps> = (props): JSX.Element => {
    const translations = useSelector(state => state.dictionary.translations);
    const fallback = isDevelopment() ? props.name : "";

    return (
        <Fragment>
            {/* String */}
            {!props.html ? (
                <Fragment>{translations && translations[props.name] ? translations[props.name] : fallback}</Fragment>
            ) : null}

            {/* HTML */}
            {props.html === true ? (
                <span dangerouslySetInnerHTML={{ __html: translations && translations[props.name] ? translations[props.name] : fallback }} />
            ) : null}
        </Fragment>
    );
};

export default Dictionary;